import React, { useState, useEffect } from 'react'
import useAuth from '@/hooks/auth'
import { UserProps } from '../../../types/user'
import User from './user'

interface Props {
  user: UserProps
}

const UserContainer = (props: Props) => {
  // eslint-disable-next-line react/destructuring-assignment
  const [ user, setUser ] = useState(props.user)
  const { currentUser: currUser, loggedin } = useAuth()
  const currentUser = loggedin ? currUser : { username: '' }

  useEffect(
    () => {
      setUser(props.user)
    },
    // eslint-disable-next-line react/destructuring-assignment
    [ props.user ],
  )
  return (
    <User
      user={user}
      isMe={user.username === currentUser.username}
      onUpdate={(data) => setUser(data)}
      isAdmin={!!currentUser && currentUser.role === 'admin'}
    />
  )
}

export default UserContainer
